// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lWTJy-Z_zjAVhH-tGWa__","is-open":"_2d-JFmkwmWr8mmO40V6NAb","show-more-container":"JNNEjGKJQyOcFkQT_80g1"};